var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.002 0C44.7747 0 0.00195312 44.7727 0.00195312 100C0.00195312 155.227 44.7747 200 100.002 200C155.229 200 200.002 155.227 200.002 100C200.002 44.7727 155.229 0 100.002 0ZM143.347 83.0909C144.146 82.1786 144.753 81.1158 145.135 79.9652C145.516 78.8145 145.663 77.5992 145.568 76.3908C145.473 75.1823 145.137 74.0051 144.58 72.9284C144.023 71.8517 143.256 70.8973 142.325 70.1213C141.394 69.3453 140.317 68.7633 139.157 68.4097C137.998 68.056 136.779 67.9378 135.574 68.0621C134.368 68.1863 133.199 68.5504 132.136 69.133C131.073 69.7156 130.137 70.505 129.384 71.4545L90.2929 118.355L70.0656 98.1182C68.351 96.4622 66.0546 95.5459 63.671 95.5666C61.2874 95.5873 59.0073 96.5434 57.3218 98.2289C55.6363 99.9145 54.6802 102.195 54.6595 104.578C54.6387 106.962 55.5551 109.258 57.211 110.973L84.4838 138.245C85.377 139.138 86.4464 139.835 87.6239 140.291C88.8014 140.748 90.061 140.954 91.3226 140.897C92.5841 140.84 93.8199 140.52 94.9511 139.959C96.0824 139.397 97.0842 138.606 97.8929 137.636L143.347 83.0909Z",
    fill: "#05C009"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.3a9bca27204b339de5ec76ddf38f40b2.svg";
export { ForwardRef as ReactComponent };